import React, { useState } from "react";
import styles from "./styles.module.scss";
import { Button, Icon, Spacing, Title } from "@sicredi/react";
import { FixedCategories, FixedNavigation } from "../Header/MenuCategories";
import RedirectAccount from "../RedirectAccount";

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  // const { handleGoNextPage } = useRouter();

  const title: any = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "27px 16px",
        backgroundColor: "#FAFAFA",
      }}
    >
      <Title as="h3" style={{ margin: "auto" }}>
        Menu
      </Title>
      <Button data-testid="close-sidebar" onClick={() => setIsOpen(!isOpen)}>
        <Icon name="close" color={"#3FA111"} />
      </Button>
    </div>
  );

  return (
    <div
      data-testid="sidebar"
      style={{
        margin: "0 32px 0 0",
      }}
    >
      <Button
        data-testid="open-sidebar"
        style={{ width: "auto" }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Icon name="menu" />
      </Button>
      {isOpen && (
        <div data-testid="sidenav" className={styles["sidenav"]}>
          {title}
          <RedirectAccount />
          <div>
            <Title as="h5">
              Viagens <strong>(você está aqui)</strong>
            </Title>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <FixedNavigation setIsOpen={setIsOpen} />
            <FixedCategories />
          </div>
          <Spacing appearance="large" />
          {/* <Button
            data-testid="be-partner-sidebar"
            appearance="primary"
            size="large"
            onClick={() => handlerRouters(PAGE.BENEFITS_PARTNER(), true)}
          >
            Quero ser um parceiro
          </Button> */}
        </div>
      )}
    </div>
  );
}
